module.exports = __webpack_public_path__ + "static/media/article-sfaa.c3f7f7e6.png";